import React, { Fragment, useEffect, useMemo } from "react";
import Section from "./Section";
// import useMeasure from "react-use/lib/useMeasure";
import log from "cslog";
import { useAtom } from "jotai";
// import { useRouter } from "next/router";
import { useRouter } from "../../../juntion";
import useWindowSize from "react-use/lib/useWindowSize";
import { PAGE_AFTER_ID } from "../../../../data/defaults";
// import { useContent } from "../../../../dynamicdata/query";
import { useContent } from "../../../junctionAbs";
import { globalVarsAtom, usePageDbConfig } from "../../../db";
import { PAGE_BEFORE_ID } from "../../../juntion";
import ActionUI from "./special/ActionUI";
import QLightbox from "./special/QLightbox";
// import dynamic from "next/dynamic";

// const TrackPageView = dynamic(
// 	() => import("../../../../analytics/TrackPageView"),
// 	{ ssr: false }
// );


const PAGE_SEPERATOR_HEIGHT = 10;

function Page({
	id,
	db,
	gs,
	dydb,
	info,
	root_info,
	layout,
	page_info,
	pageBeforeData,
	pageAfterData,
	ctx,
	query,
	load_fonts = false
}) {
	const router = useRouter();
	const { width, height } = useWindowSize(1024, undefined);
	const data = db[id];
	const gv = useAtom(globalVarsAtom);

	const device = width;
	// const device = 1200;

	// log.d(info, "Page Infoo");

	// useEffect(() => {
	//     log.p("Now scrolling to top");
	//     window.scrollTo(0, 0);
	// }, []);

	// log.d(ctx, "CTX in page");

	useEffect(() => {
		const handleRouteChange = (url, { shallow }) => {
			window.scroll({
				top: 0,
				left: 0,
				behavior: "smooth",
			});
		};

		router?.events?.on("routeChangeComplete", handleRouteChange);

		return () => {
			router?.events?.off("routeChangeComplete", handleRouteChange);
		};
	}, []);

	// ===========================================
	const page_before_data = pageBeforeData.html[PAGE_BEFORE_ID];

	let page_after_data = null;
	if (pageAfterData) {
		page_after_data = pageAfterData.html[PAGE_AFTER_ID];
	}

	const paths = useMemo(() => {
		// log.p("Recalculating paths");
		const out = {};
		if (info.paths?.length > 0) {
			info.paths.forEach((path, index) => {
				out[path] = query[index + 2];
			});
		}
		return out;
	}, [query, info.paths]);

	const [dbc, setDBC] = usePageDbConfig(id);
	// log.d(dydb, "Unparsed db in page");
	const content = useContent(dydb, dbc, paths, ctx?.organization);
	const all_content = {
		gv: {
			status: "success",
			isSuccess: true,
			// data: globalVariables,
			data: gv,
		},
		...content,
	};


	const is_document = root_info.type === "document";


	const layout_default = layout?.["default"];
	const page_dims = layout_default?.pageSize?.value || {}; // for document
	const page_margin = layout_default?.pageMargins?.params || { left: 0, right: 0, top: 0, bottom: 0 };
	const page_dims_inner = {
		width: page_dims.width - page_margin.left - page_margin.right,
		height: page_dims.height - page_margin.top - page_margin.bottom,
		margin: page_margin,
	}; // for document

	// log.d(is_document, "is_document in Page")
	// log.d(root_info, "root_info in Page")
	// log.d(layout, "Layout in Page")
	// log.d(page_dims_inner, "page_dims_inner in Page")

	return (
		<PageWrapper is_document={is_document} background={layout_default?.background?.value} page_dims={page_dims}>
			{/* <TrackPageView /> */}
			{id !== PAGE_BEFORE_ID &&
				!page_info.hidePageBefore &&
				page_before_data.sections.map((item, index) => {
					return (
						<Section
							id={item}
							index={index}
							key={index}
							device={device}
							gs={gs}
							db={pageBeforeData.html}
							// dydb={dydb}
							dydb={all_content}
							ctx={ctx}
							page_dims_inner={page_dims_inner}
							is_document={is_document}
						/>
					);
				})}
			{data.sections.map((item, index) => {
				return (
					<Section
						key={item}
						id={item}
						index={index}
						db={db}
						// dydb={dydb}
						dydb={all_content}
						gs={gs}
						device={device}
						ctx={ctx}
						page_dims_inner={page_dims_inner}
						is_document={is_document}
					/>
				);
			})}
			{id !== PAGE_AFTER_ID &&
				!page_info.hidePageAfter &&
				page_after_data &&
				page_after_data.sections.map((item, index) => {
					return (
						<Section
							id={item}
							index={index}
							key={index}
							device={device}
							gs={gs}
							db={pageAfterData.html}
							// dydb={dydb}
							dydb={all_content}
							ctx={ctx}
							page_dims_inner={page_dims_inner}
							is_document={is_document}
						/>
					);
				})}

			<ActionUI db={pageBeforeData.html} gs={gs} device={device} />
			<QLightbox />

			{load_fonts && [gs.config?.primaryFont, gs.config?.secondryFont].map((font) => {
				return (
					<link
						key={font}
						href={`https://fonts.googleapis.com/css2?family=${font}&display=swap`}
						rel="stylesheet"
						crossOrigin="anonymous"
					/>
				);
			})}
		</PageWrapper>
	);
}

export default Page;


function PageWrapper({ is_document, background, children, page_dims }) {
	if (is_document) {
		return <div style={{
			backgroundColor: background,
			height: "auto",
			minHeight: page_dims?.height ? page_dims.height + PAGE_SEPERATOR_HEIGHT : "100%",
		}}>{children}</div>
	} else {
		return children
	}
}